// sortable: 'custom'
export const contentTableConfig = {
  title: '三方直播大屏数据列表',
  propList: [
    {prop: 'thirdParty', label: '三方名称', minWidth: '100', slotName: 'thirdParty'},
    {prop: 'accountName', label: '直播间名称', minWidth: '100', },
    {prop: 'liveStatus', label: '直播状态', minWidth: '80', slotName: 'liveStatus'},
    {prop: 'watchUv', label: '观看人数', minWidth: '80', slotName: 'watchUv'},
    {prop: 'newFollowUv', label: '新增关注', minWidth: '80', slotName: 'newFollowUv'},
    {prop: 'newFollowRate', label: '新增关注率', minWidth: '80', slotName: 'newFollowRate'},
    {prop: 'shareUv', label: '分享人数', minWidth: '80', slotName: 'shareUv'},
    {prop: 'shareRate', label: '分享率', minWidth: '80', slotName: 'shareRate'},
    {prop: 'likeCount', label: '点赞数', minWidth: '80'},
    {prop: 'commentCount', label: '评论数', minWidth: '80'},
    {prop: 'startTime', label: '开播时间', minWidth: '80'},
    {prop: 'endTime', label: '结束时间', minWidth: '80'},
    {prop: 'liveDuration', label: '直播时长', minWidth: '80'},

  ],
  showIndexColumn: false,
  showSelectColumn: false
}
